import {
  ICustomDomainLinkableResponse,
  ICustomDomainResponse,
  ICustomDomainSpfCheckResponse,
  ICustomDomainUpdateRequest,
} from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';
import { CacheTags } from '../../types/cacheTags';

export const customDomainApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchCustomDomain: builder.query<ICustomDomainResponse, string>({
      query: organisationId => ({
        url: `custom-domain`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      providesTags: [
        { type: CacheTags.CustomDomain, id: `LIST` },
      ],
    }),
    updateCustomDomain: builder.mutation<ICustomDomainResponse, { organisationId: string } & ICustomDomainUpdateRequest>({
      query: ({ organisationId, domain }) => ({
        url: `custom-domain`,
        method: `PUT`,
        data: { domain },
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      invalidatesTags: [
        { type: CacheTags.CustomDomain, id: `LIST` },
      ],
    }),
    verifyCustomDomain: builder.mutation<void, string>({
      query: organisationId => ({
        url: `custom-domain/verify`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      invalidatesTags: [
        { type: CacheTags.CustomDomain, id: `LIST` },
      ],
    }),
    requestCustomDomainAccess: builder.mutation<void, string>({
      query: organisationId => ({
        url: `custom-domain/requestAccess`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
    }),
    sendCustomDomainDns: builder.mutation<void, { organisationId: string; emails: string }>({
      query: ({ organisationId, emails }) => ({
        url: `custom-domain/sendDns`,
        method: `POST`,
        data: { emails },
        headers: {
          [orgHeader]: organisationId,
        },
      }),
    }),
    getCustomDomainLinkable: builder.query<ICustomDomainLinkableResponse, { organisationId: string; domain?: string }>({
      query: ({ organisationId, domain }) => ({
        url: `custom-domain/linkable`,
        method: `GET`,
        params: domain ? { domain } : undefined,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      providesTags: [
        { type: CacheTags.CustomDomain, id: `LIST` },
      ],
    }),
    linkCustomDomain: builder.mutation<void, { organisationId: string; sourceOrganisationId: string }>({
      query: ({ organisationId, sourceOrganisationId }) => ({
        url: `custom-domain/link`,
        method: `POST`,
        data: { sourceOrganisationId },
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      invalidatesTags: [
        { type: CacheTags.CustomDomain, id: `LIST` },
      ],
    }),
    checkCustomDomainSpf: builder.query<ICustomDomainSpfCheckResponse, string>({
      query: organisationId => ({
        url: `custom-domain/spf`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      providesTags: [
        { type: CacheTags.CustomDomain, id: `LIST` },
      ],
    }),
  }),
});

export const {
  useFetchCustomDomainQuery,
  useUpdateCustomDomainMutation,
  useVerifyCustomDomainMutation,
  useRequestCustomDomainAccessMutation,
  useSendCustomDomainDnsMutation,
  useCheckCustomDomainSpfQuery,
  useGetCustomDomainLinkableQuery,
  useLinkCustomDomainMutation,
} = customDomainApi;
